import * as React from 'react';

import IUserModel from '../../models/IUserModel';
import UserPlantsQuery from '../user/queries/UserPlantsQuery';
import IPlantModel from './../../models/IPlantModel';
import MultiSelect from '../ui/MultiSelect';

interface IProps {
    onUpdate?: (id: string) => void;
    defaultSelected?: string;
    disabled?: boolean;
    showPlaceHolder?: boolean;
}

interface IState {
    plant: string;
}

export default class PlantListDropdown extends React.Component<IProps, IState> {
    public state: IState = {
        plant: '',
    };

    public componentDidMount() {
        this.setState({ plant: this.props.defaultSelected || '' });
    }

    private handleChange = (option: { value: string; label: string } | null): void => {
        const { onUpdate } = this.props;
        if (typeof onUpdate === 'function') {
            onUpdate(option ? option.value : '');
        }
    };

    private buildSelectOptions = (plants: IPlantModel[]) => {
        return plants.map(plant => ({
            value: plant.id,
            label: plant.name,
        }));
    };

    private renderSelectMenu = (user: IUserModel, plants: IPlantModel[]) => {
        void user;
        const { defaultSelected, disabled } = this.props;

        const options = this.buildSelectOptions(plants);
        const selectedOption = defaultSelected
            ? options.find(opt => opt.value === defaultSelected)
            : undefined;

        return (
            <MultiSelect
                value={selectedOption}
                options={options}
                placeholder="Select Plant"
                isDisabled={disabled}
                isClearable={false}
                onChange={this.handleChange}
            />
        );
    };

    public render() {
        return <UserPlantsQuery renderFetchedPlantData={this.renderSelectMenu} />;
    }
}
